import React from "react";

import { IconWrapper } from "../styled-components";

import { ReactComponent as EQUINORLOGO } from "./Equinor.svg";
import styled from "styled-components";

const StyledBANENORLOGO = styled(EQUINORLOGO)``;

const StyledSecurityIconDark = styled(EQUINORLOGO)``;

type EquinorLogoProps = {
  /**
   * Scale the icon relative to a base size of 2rem
   */
  scale?: number;
  /**
   * An alternative text that is read by a screen reader for accessibility purposes.
   */
  altText: string;
  /* light or dark mode*/
  light?: boolean;
};

const EquinorLogo: React.FC<EquinorLogoProps> = ({
  scale = 1,
  altText,
  light,
}) => {
  return (
    <IconWrapper width={2 * scale} height={2 * scale} aria-label={altText}>
      <StyledBANENORLOGO />
    </IconWrapper>
  );
};

export default EquinorLogo;
